import List from '../views/settings/list'

export default [
    {
        path: '/admin/settings',
        name: 'settings',
        component: List,
    }
]
